import {
    Role,
    ExplicitRole,
    ImplicitRole,
    ClientRole,
    ExplicitClientRole,
    TeamRole,
    ExplicitTeamRole,
    UserRole,
    ExplicitUserRole,
    SuperUserRole,
} from '../generated/types';

export type AnyRole =
    | Role
    | ExplicitRole
    | ImplicitRole
    | ClientRole
    | ExplicitClientRole
    | TeamRole
    | ExplicitTeamRole
    | UserRole
    | ExplicitUserRole;

export function isRole(value: unknown): value is Role {
    return typeof value === 'string' && value in Role;
}

export function isImplicitRole(value: unknown): value is ImplicitRole {
    return typeof value === 'string' && value in ImplicitRole;
}

export function isExplicitRole(value: unknown): value is ExplicitRole {
    return typeof value === 'string' && value in ExplicitRole;
}

export function isClientRole(value: unknown): value is ClientRole {
    return typeof value === 'string' && value in ClientRole;
}

export function isExplicitClientRole(
    value: unknown
): value is ExplicitClientRole {
    return typeof value === 'string' && value in ExplicitClientRole;
}

export function isTeamRole(value: unknown): value is TeamRole {
    return typeof value === 'string' && value in TeamRole;
}

export function isExplicitTeamRole(value: unknown): value is ExplicitTeamRole {
    return typeof value === 'string' && value in ExplicitTeamRole;
}

export function isUserRole(value: unknown): value is UserRole {
    return typeof value === 'string' && value in UserRole;
}

export function isExplicitUserRole(value: unknown): value is ExplicitUserRole {
    return typeof value === 'string' && value in ExplicitUserRole;
}

export function isSuperUserRole(value: unknown): value is SuperUserRole {
    return typeof value === 'string' && value in SuperUserRole;
}
